module.exports = __webpack_public_path__ + "img/36_23.8daf478d.png";